import isEmpty from 'lodash/isEmpty';

const retryableTaskTypes = new Set(['Http', 'JQ', 'Email', 'Map', 'AIChat', 'JsonDocumentReader', 'TextDocumentReader', 'HtmlDocumentReader', 'MarkdownDocumentReader', 'YamlDocumentReader', 'JsonConverter', 'AIVectorStore', 'AIVectorSearch', 'AIVectorDelete']);

export const taskSupportsRetryControls = task => retryableTaskTypes.has(task?.type);

export const cellSupportsRetryControls = cell => taskSupportsRetryControls(cell?.getValue?.()) ||
    (cell?.isStart?.() === true && cell?.isSplit?.() === true);

export const cellSupportsParallelMetadataRetryControls = cell => cell?.isStart?.() !== true && cell?.isSplit?.() === true;

export const taskSupportsInputParameterControls = task => task?.type !== 'Terminate';

export const cellSupportsInputParameterControls = cell => taskSupportsInputParameterControls(cell?.getValue?.());

export const transitionInputParametersTaskValuePath = (cell, model) => {
    if (!cell || cell.isStart?.() === true) {
        return null;
    }

    const task = cell?.getValue?.();
    if (task?.splitType === 'And') {
        return 'parallelTask';
    }

    const outgoingRoutes = model?.getEdges?.(cell, false, true, true) || cell?.edges || [];
    return !isEmpty(task?.decisionTask?.name)
        || outgoingRoutes.length > 1
        || outgoingRoutes.some(route => route?.isConditional?.() || route?.value?.routingType === 'Conditional')
        ? 'decisionTask'
        : null;
};

export const cellSupportsRoutingParameters = (cell, model) => {
    if (!cell) {
        return false;
    }

    const outgoingRoutes = model?.getEdges?.(cell, false, true, true) || cell.edges || [];
    return cell.isStart?.() === true
        ? outgoingRoutes.length > 1
        : transitionInputParametersTaskValuePath(cell, model) !== null;
};
